export default class RegisteredActionType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const REGISTERED_ACTION_TYPES = {
  START_PROJECT_EXECUTION: new RegisteredActionType('Start uitvoering', 0),
  STOP_PROJECT_EXECUTION: new RegisteredActionType('Stop uitvoering', 1),
  REGISTER_IMMO_PRINT: new RegisteredActionType('Immo printwerk', 2),
  REGISTER_IMMO_TEXT: new RegisteredActionType('Immo text', 3),
  REGISTER_IMMO_EXTRA_BOARD_TEXT: new RegisteredActionType(
    'Immo extra bord text',
    4
  )
};
